import { render } from "./ModalCookieDetail.vue?vue&type=template&id=6348d35a"
import script from "./ModalCookieDetail.vue?vue&type=script&lang=js"
export * from "./ModalCookieDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__